/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const problemStakeholderDtoSchema = z.object({
  stakeholder: z.optional(z.string()),
  role: z.optional(z.string()),
  pain: z.optional(z.string()),
});
